import React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { httpRequest } from '../api/helper';
import { Box } from '@mui/material';
import { useNotification } from '../context/NotificationContext';
import { AuthContext } from '../context/AuthContext';
import { DEFAULT_ERROR_MESSAGE, AUTH_URLS } from '../common/AppConstants';
import { notifyClientErrors } from '../common/AppUtils';
import * as AppUrls from '../common/AppUrls';
import logger from '../logger';

export default function GoogleLoginButton({ event_type="signin", event_data={} }) {
  const { addNotification } = useNotification();
  const navigate = useNavigate();
  const { login } = React.useContext(AuthContext);
  const [containerWidth, setContainerWidth] = useState(364);  // with maxWidth="xs", MUI caps container to 444px - margins = 364px

  const containerRef = useRef(null);
 
  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver(() => {
        if (containerRef.current) {
          console.log(`Width=${containerRef.current.offsetWidth}`);
          setContainerWidth(containerRef.current.offsetWidth);
        }
      });
      resizeObserver.observe(containerRef.current);

      return () => resizeObserver.disconnect();
    }
  }, []);

  const handleGoogleLoginSuccess = async (googleResponse) => {
    await httpRequest({
      method: 'POST',
      url: AUTH_URLS.GOOGLE_LOGIN,
      data: {
        event_type: event_type,
        google_token: googleResponse.credential,
        terms_accepted: true, // Google's Login screen asks to review before continuing
        profile_id: event_data.profile_id,      // event="invite"
        invite_token: event_data.invite_token,  // event="invite"
        invite_type: event_data.invite_type,    // event="invite"
      },
      onSuccess: (data) => {
        login(data.access, data.refresh);
        navigate(AppUrls.DASHBOARD_URL);
      },
      addNotification,
    });
  };

  const handleGoogleLoginFailure = (error) => {
    console.error('Google login error: ', error);
    addNotification('Google login has failed.', 'error');
  };

  return (
    <Box
      ref={containerRef}
      sx={{
        display: 'flex',            // horizontal alignment sometime Google button renders smaller in iFrame
        justifyContent: 'center',   // horizontal alignment sometime Google button renders smaller in iFrame
        // border: '1px solid black',
        borderRadius: 1,
        width: '100%',
        mx: 'auto',
      }}
    >
      <GoogleLogin
        onSuccess={handleGoogleLoginSuccess}
        onError={handleGoogleLoginFailure}
        text={event_type === "signin" ? "signin_with" : "continue_with"}  // signin_with, signup_with, continue_with
        ux_mode="popup" // popup(default) , redirect
        useOneTap // Top right popup for quick 'sign in', might not work for 'sign up' if extra details are required
        // scope="openid email profile"
        // cookiePolicy={'single_host_origin'}
        // size="large"
        width={`${containerWidth}px`} // Manually make Google Button responive to screen width
      />
    </Box>
  );
}
